import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../..";
import { Button, Checkbox, CustomLink, Input, Layout, Result } from "../../components";
import logo from "../../assets/logo.svg";
import { Response } from "../../types";
import $api from "../../http";
import config from "../../config";
import { observer } from "mobx-react";

const CreateServicePage: FC<{ title: string }> = observer(({ title }) => {
  const navigate = useNavigate();
  const { store } = useContext(Context);
  useEffect(() => {
    if (!store.isAuth) return navigate("/");
    if (store.user.type !== "admin") return navigate(`/${store.user.type}`);
  }, [navigate, store.isAuth, store.user.type]);

  const [name, setName] = useState<string>("");
  const [price, setPrice] = useState<string>("");
  const [sale, setSale] = useState<boolean>();
  const [result, setResult] = useState<Response>({ message: "", status: "error" });

  const sendData = () => {
    setResult({ message: "", status: "error" });

    if (!name) return setResult({ status: "error", message: "Укажите название услуги" });
    if (!price || !Number(price)) return setResult({ status: "error", message: "Цена должна быть числовым значением" });
    $api.post(`${config.API}/service/create`, { name, price, sale }).then(({ data }) => {
      setResult({ status: data.status, message: data.status === "success" ? "Успешно" : data.message });
    });
  };

  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={120} height={120} style={{ marginBottom: 50 }} />
      <CustomLink to={"/admin"}>{"<-"} Админ панель</CustomLink>
      <Input placeholder="Название услуги" onChange={({ target }) => setName(target.value)} value={name} />
      <Input placeholder="Цена" onChange={({ target }) => setPrice(target.value)} value={price} />
      <Checkbox text="Со скидкой" onChange={(e: boolean) => setSale(e)} />
      <Button onClick={sendData}>Сохранить</Button>
      <Result {...result} />
    </Layout>
  );
});

export default CreateServicePage;
